import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import { SEND_PASSWORD_FINISHED } from './constants';

const initialState = fromJS({
	sendPasswordFinished: false
});

export const reducer = handleActions(
	{
		[SEND_PASSWORD_FINISHED]: (state) => state.set('sendPasswordFinished', true)
	},
	initialState
);

export default reducer;
